"use client";

import { Button } from "@/components/ui/button";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuRadioGroup,
    DropdownMenuRadioItem,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ChevronDown } from "lucide-react";
import {
    StorageFilterByType,
    storageFilterByTypeOptions,
} from "../../../../types";
import { useStorageQuery } from "../../../../hooks/storageQueryProvider";
import { t } from "@/lib/localization";
import { useLocale } from "@/hooks/useLocale";

export default function FilterByType() {
    const { dir } = useLocale();
    const { filesQuery, updateFilesQuery } = useStorageQuery();
    const filterByTypeOption = storageFilterByTypeOptions.find(
        (o) => o.value === filesQuery.filterBy
    );

    return (
        <DropdownMenu dir={dir}>
            <DropdownMenuTrigger asChild>
                <Button
                    className="gap-1 font-normal text-sm"
                    variant="outline"
                    size="sm"
                >
                    {t("storage.files-grid.filter-by-type-btn", undefined, undefined)}
                    :{" "}
                    {t(filterByTypeOption!.keyName, undefined, undefined)}
                    <ChevronDown className="size-4" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent side="bottom" align="end" className="w-40">
                <DropdownMenuRadioGroup
                    value={filesQuery.filterBy}
                    onValueChange={(value: string) => {
                        updateFilesQuery({
                            filterBy: value as StorageFilterByType,
                            page: 1,
                        });
                    }}
                >
                    {storageFilterByTypeOptions.map((option) => (
                        <DropdownMenuRadioItem
                            key={option.value}
                            value={option.value}
                            className="text-sm"
                        >
                            {t(option.keyName, undefined, undefined)}
                        </DropdownMenuRadioItem>
                    ))}
                </DropdownMenuRadioGroup>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
